import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SavyIcon from "../../../../../../src/assets/icons/savy.png";
import VectorIcon from "../../../../../../src/assets/icons/vector.png";
import TimeIcon from "../../../../../../src/assets/icons/time.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import { message } from "antd";

const Welcome = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [isAnimating, setIsAnimating] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start animations after component mounts
    setTimeout(() => setIsAnimating(true), 100);
  }, []);

  const handleButtonClick = (e) => {
    // Add ripple effect
    const button = e.currentTarget;
    const ripple = document.createElement("span");
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add("ripple");

    button.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);

    handleNext();
  };

  const handleNext = async () => {
    // Start exit animation
    setIsExiting(true);

    try {
      // Build payload dynamically
      const payload = {
        startDate: new Date().toISOString(),
        user: "6899eb6eebdd7e9cc42384da",
        income: null,
        source: "Mobile app",
        status: "In progress",
        ownCar: null,
        mileage: null,
        mileageRate: null,
        foodAndDrink: null,
        daysPerWeek: null,
        reimbursedPerDay: null,
        annualSaving: null,
        trialStarted: null,
        refundYears: 0,
        refund: null,
        onBoardingStatut: null,
        timeSpent: 0,
        mileageType: 0,
        spendPerDay: 0,
        annualExpenses: 0,
      };

      // API call
      const response = await axios.post(
        "https://api.savyapp.dev/api/v1/estimations/user/me",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Estimation created:", response.data);
      const estimationId = response.data.id;
      localStorage.setItem("estimationId", estimationId);

      // Wait for exit animation before navigating
      setTimeout(() => {
        navigate(`/preview/flow/${id}/question`);
      }, 300);
    } catch (error) {
      console.error("Error creating estimation:", error);
      setIsExiting(false);
      message.error("Failed to start. Please try again.");
    }
  };

  return (
    <div
      className={`flex flex-col h-full bg-white transition-all duration-500 ${
        isExiting ? "opacity-0 scale-95" : "opacity-100 scale-100"
      }`}
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
      }}
    >
      {/* Main Content - Centered */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 min-h-0">
        <div className="w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-6 sm:space-y-8 md:space-y-10">
          {/* Welcome - Section 1 */}
          <p
            className={`text-base sm:text-lg md:text-xl font-bold bg-gradient-to-r from-[#8AB9F1] via-[#b57edc] to-[#F08080] bg-clip-text text-transparent transition-all duration-700 ease-out ${
              isAnimating
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: "100ms" }}
          >
            Welcome to
          </p>

          {/* Logo Section - Savy + Vector */}
          <div className="flex flex-col items-center space-y-3 sm:space-y-4 pb-6 sm:pb-8 md:pb-10">
            <div
              className={`transition-all duration-700 ease-out ${
                isAnimating
                  ? "opacity-100 scale-100 translate-y-0"
                  : "opacity-0 scale-90 translate-y-4"
              }`}
              style={{ transitionDelay: "300ms" }}
            >
              <img
                src={SavyIcon}
                alt="Savy"
                className="w-auto h-10 sm:h-12 md:h-14 lg:h-16 max-w-[200px] sm:max-w-[240px] md:max-w-[280px]"
              />
            </div>
            <div
              className={`transition-all duration-700 ease-out ${
                isAnimating
                  ? "opacity-100 scale-100 translate-y-0"
                  : "opacity-0 scale-90 translate-y-4"
              }`}
              style={{ transitionDelay: "500ms" }}
            ></div>
          </div>

          {/* Heading - Section 4 */}
          <div
            className={`flex flex-col items-center space-y-3 sm:space-y-4 transition-all duration-700 ease-out ${
              isAnimating
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: "700ms" }}
          >
            <img
              src={VectorIcon}
              alt="Vector"
              className="w-auto h-8 sm:h-10 md:h-12 lg:h-14 max-w-[160px] sm:max-w-[180px] md:max-w-[220px] lg:max-w-[260px]"
            />
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
              We help taxpayers{" "}
              <span className="bg-gradient-to-r from-[#b57edc] to-[#F08080] bg-clip-text text-transparent">
                get refunds
              </span>
              <br /> for work travel costs.
            </h1>
          </div>

          {/* Time Icon + Subheading */}
          <div className="flex flex-col items-center space-y-3 sm:space-y-4">
            <div
              className={`transition-all duration-700 ease-out ${
                isAnimating
                  ? "opacity-100 scale-100 translate-y-0"
                  : "opacity-0 scale-90 translate-y-4"
              }`}
              style={{ transitionDelay: "900ms" }}
            >
              <img
                src={TimeIcon}
                alt="Time"
                className="w-auto h-8 sm:h-9 md:h-10 max-w-[120px] sm:max-w-[140px] md:max-w-[160px]"
              />
            </div>
            <p
              className={`text-sm sm:text-base md:text-lg font-medium text-gray-800 leading-relaxed transition-all duration-700 ease-out ${
                isAnimating
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }`}
              style={{ transitionDelay: "1100ms" }}
            >
              Give us{" "}
              <span className="bg-gradient-to-r from-[#b57edc] to-[#F08080] bg-clip-text text-transparent font-semibold">
                3 mins
              </span>{" "}
              and we'll tell you how much you can save.
            </p>
          </div>
        </div>
      </div>

      {/* Footer Button - Fixed at bottom */}
      <div className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-5 bg-white flex-shrink-0">
        <div className="max-w-2xl mx-auto">
          <button
            onClick={handleButtonClick}
            className={`w-full bg-[#002147] text-white font-semibold py-2.5 sm:py-3 rounded-lg hover:bg-[#003366] focus:bg-[#003366] focus:outline-none focus:ring-2 focus:ring-[#002147]/30 shadow-md hover:shadow-lg transform hover:scale-[1.01] active:scale-[0.99] relative overflow-hidden transition-all duration-200 ${
              isAnimating
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }`}
            style={{
              transitionDelay: "1300ms",
            }}
          >
            <span className="relative z-10">Next →</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
